import { MoreOutlined, PlusOutlined, UpOutlined } from "@ant-design/icons";
import {
  IBriefInfluencerSearchRequestV2,
  IBriefInfluencerV2,
  IFieldConfig,
  IInfluencerContact,
} from "@shared/lib/types/briefInfluencerV2";
import {
  Button,
  Divider,
  Dropdown,
  Flex,
  Form,
  Input,
  Modal,
  Popover,
  Row,
  Space,
  Spin,
} from "antd";

import { SelectContact } from "@entities/brief/ui/Influencer/v2/SelectContact";
import { BrandCommercial } from "@features/brandCommercials/BrandCommercials";
import { InfluencerCommercial } from "@features/infleuncerCommercials/InfluencerCommercials";
import { ToastService } from "@shared/lib/services";
import { Popconfirm } from "@shared/ui";
import { useEffect, useState } from "react";

import { useAttachBriefDeliverable } from "@entities/brief/lib/hooks/useAttachDeliverable";
import useBulkActions from "@entities/brief/lib/hooks/useBulkActions";
import { useGetBriefInfluencerPurchaseStatus } from "@entities/brief/lib/hooks/useGetBriefInfluencerPurchaseStatus";
import { usePurchaseNonProfitable } from "@entities/brief/lib/hooks/usePurchaseNonProfitable";
import SuggestInfluencerPricingForm from "@entities/brief/ui/SuggetInfluencerPricing";
import { AddCustomFieldsDataButton } from "@features/AddCustomFieldsDataButton";
import { AddToCampaignFromBrief } from "@features/AddtoCampaignFromBrief";
import { AssignPricingModalV2 } from "@features/assignPricingModal/AssignPricingModalV2";
import { AddDeliverablesButton } from "@features/CampaignDeliverables/AddDeliverablesButton";
import { PurchaseConfirmation } from "@features/purchaseConfirmation/PurchaseConfirmation";
import {
  InvalidInfluencer,
  PurchasePreCheckModalContent,
} from "@features/purchaseConfirmation/PurchasePreCheckModal";
import { useBriefStore } from "@pages/layout/BriefLayout/lib/useLayoutStore";
import { BriefNotificationActionType } from "@shared/lib/types/brief";
import SuggestCampaignFromBriefForm from "@shared/ui/InfluencerTable/SuggestCampaignFromBriefForm";
import AddToBucket from "@shared/ui/Modals/AddToBucket";
export function BriefPricingActions({
  selectedRowKeys,
  setSelectedRowKeys,
  selectedRows,
  setSelectedRows,
  refetch,
  params,
  updateBriefInfluencers,
  visibleCustomFields,
  selectAll,
  uncheckList,
  setSelectAll,
  setUncheckList,
  totalCount,
  briefInfluencers,
}: {
  selectedRowKeys: React.Key[];
  setSelectedRowKeys: React.Dispatch<React.SetStateAction<React.Key[]>>;
  selectedRows: IBriefInfluencerV2[];
  setSelectedRows: React.Dispatch<React.SetStateAction<IBriefInfluencerV2[]>>;
  refetch?: () => void;
  params?: IBriefInfluencerSearchRequestV2;
  updateBriefInfluencers: (
    data: { id: string; briefInfluencer: IBriefInfluencerV2 }[]
  ) => void;
  visibleCustomFields: IFieldConfig[];
  selectAll?: boolean;
  uncheckList?: string[];
  setSelectAll?: (val: boolean) => void;
  setUncheckList?: (val: string[]) => void;
  totalCount?: number;
  briefInfluencers?: IBriefInfluencerV2[];
}) {
  const { brief, briefId } = useBriefStore();
  const [isSuggestModalOpen, setSuggestModalOpen] = useState<boolean>(false);
  const [declinePopoverVisible, setDeclinePopoverVisible] =
    useState<boolean>(false);
  const [declineType, setDeclineType] = useState<"creator" | "brand" | null>(
    null
  );
  const [
    isSuggestInfluencerPricingModalOpen,
    setIsSuggestInfluencerPricingModalOpen,
  ] = useState<boolean>(false);

  const [selectedDeliverableForAttach, setSelectedDeliverableForAttach] =
    useState<{ _id: string } | null>(null);
  const {
    attachBriefDeliverable,
    isAttaching,
    isAttached,
    attachBriefDeliverableError,
  } = useAttachBriefDeliverable(briefId);
  const [conatcsModalProps, setContactsModalProps] = useState<{
    visible: boolean;
    briefInfluencerId: string;
    conatcts: IInfluencerContact[];
    addContactOnly?: boolean;
    creatorInfo:
      | {
          name: string;
          dp: string;
          rating: number;
        }
      | undefined;
    initialContact: IInfluencerContact | null;
  }>({
    visible: false,
    briefInfluencerId: "",
    creatorInfo: undefined,
    conatcts: [],
    addContactOnly: false,
    initialContact: null,
  });

  const [openAddToCampaignProps, setOpenAddToCampaignProps] = useState<{
    open: boolean;
  }>({
    open: false,
  });

  const [infCommercialsModalProps, setInfluencerModalProps] = useState<{
    visible: boolean;
    briefInfluencer?: IBriefInfluencerV2;
    type: "view" | "create-new" | "create";
  }>({
    visible: false,
    type: "create",
  });

  const [brandCommercialsModalProps, setBrandluencerModalProps] = useState<{
    visible: boolean;
    briefInfluencer?: IBriefInfluencerV2;
    type: "view" | "create-new";
  }>({
    visible: false,
    type: "view",
  });
  // ── Purchase flow state ────────────────────────────────────────────────
  const [purchaseModalProps, setPurhcaseModalProps] = useState<{
    visible: boolean;
    briefInfluencers?: IBriefInfluencerV2[];
  }>({
    visible: false,
  });

  // Precheck modal: shows valid/invalid split before proceeding to PurchaseConfirmation
  const [purchasePreCheckVisible, setPurchasePreCheckVisible] = useState(false);
  const [preCheckValidCreators, setPreCheckValidCreators] = useState<IBriefInfluencerV2[]>([]);
  const [preCheckInvalidCreators, setPreCheckInvalidCreators] = useState<InvalidInfluencer[]>([]);

  const [purchaseResult, setPurchaseResult] = useState<{
    nextActionToTake: string;
    result: {
      status: string;
      reason: string;
      briefInfluencer: IBriefInfluencerV2;
    }[];
  } | null>(null);
  const [showNonProfitableModal, setShowNonProfitableModal] = useState(false);

  const {
    purchaseNonProfitable,
    isPurchasingNonProfitable,
    isPurchasedNonProfitable,
  } = usePurchaseNonProfitable(briefId);

  const [form] = Form.useForm();

  useEffect(() => {
    if (isPurchasedNonProfitable) {
      ToastService.success("Purchased Non Profitable");
      setShowNonProfitableModal(false);
      setSelectedRowKeys([]);
      setSelectedRows([]);
    }
  }, [isPurchasedNonProfitable]);

  useEffect(() => {
    if (isAttached) {
      ToastService.success("Deliverable attached successfully.");
      setSelectedDeliverableForAttach(null);
      refetch?.();
    } else if (attachBriefDeliverableError) {
      ToastService.error(attachBriefDeliverableError?.message);
    }
  }, [isAttached, attachBriefDeliverableError, refetch]);

  const [preConfirmModal, setPreConfirmModal] = useState<{
    visible: boolean;
    negotiationCount: number;
    brandPendingCount: number;
  }>({
    visible: false,
    negotiationCount: 0,
    brandPendingCount: 0,
  });

  // purchaseStatus hook — triggered by precheck modal open
  const { purchaseStatus, isFetching: isPurchaseStatusFetching, isSuccess: isPurchaseStatusSuccess } =
    useGetBriefInfluencerPurchaseStatus(purchasePreCheckVisible, {
      briefInfluencerIds: selectedRowKeys as string[],
      isSelectAll: selectAll,
      notIncludeIds: uncheckList,
      filterParams: params || {},
    });

  // When precheck modal loads, populate valid/invalid from API results
  useEffect(() => {
    if (
      purchasePreCheckVisible &&
      purchaseStatus.length > 0 &&
      !isPurchaseStatusFetching &&
      isPurchaseStatusSuccess
    ) {
      const valid = purchaseStatus
        .filter((inf) => inf.status === "success")
        .map((inf) => inf.briefInfluencer);
      const invalid: InvalidInfluencer[] = purchaseStatus
        .filter((inf) => inf.status === "failed")
        .map((inf) => ({
          ...inf.briefInfluencer,
          reason: inf.reason || "Cannot be purchased",
        }));
      setPreCheckValidCreators(valid);
      setPreCheckInvalidCreators(invalid);
    }
  }, [
    purchasePreCheckVisible,
    purchaseStatus,
    isPurchaseStatusFetching,
    isPurchaseStatusSuccess,
  ]);

  // Reset precheck state when modal closes
  useEffect(() => {
    if (!purchasePreCheckVisible) {
      setPreCheckValidCreators([]);
      setPreCheckInvalidCreators([]);
    }
  }, [purchasePreCheckVisible]);

  function handleBulkPurchase() {
    if (selectAll) {
      // For selectAll: open precheck modal directly — purchaseStatus API handles the filtering
      setPurchasePreCheckVisible(true);
      return;
    }
    // Existing partial-selection flow: also open precheck which now shows valid/invalid
    const negotiationCount = selectedRows.filter(
      (row) => row.isNewCommericalRequested
    ).length;
    const brandPendingCount = selectedRows.filter(
      (row) => row.isBrandNewCostPending
    ).length;
    if (negotiationCount > 0 || brandPendingCount > 0) {
      setPreConfirmModal({
        visible: true,
        negotiationCount,
        brandPendingCount,
      });
      return;
    }
    // Open precheck which will show valid/invalid from purchaseStatus API
    setPurchasePreCheckVisible(true);
  }

  const [bucketId, setselectedbuckedId] = useState<string>("");
  const [isBucketModalVisible, setBucketModalVissible] =
    useState<boolean>(false);

  const effectiveCount =
    selectAll && totalCount
      ? totalCount - (uncheckList?.length || 0)
      : selectedRowKeys.length;

  const isReAssginOrRemoveVisible = selectAll || selectedRowKeys.length > 0;

  const [pricingPocModalProps, setPricingPocModalProps] = useState<{
    visible: boolean;
    briefInfluencerId: string[];
    type: "assign" | "reassign" | "remove";
  }>({
    visible: false,
    briefInfluencerId: [],
    type: "assign",
  });

  const openPricingPocModal = (
    briefInfluencerId: string[] | string,
    type: "assign" | "reassign" | "remove"
  ) => {
    setPricingPocModalProps({
      visible: true,
      briefInfluencerId: Array.isArray(briefInfluencerId)
        ? briefInfluencerId
        : [briefInfluencerId],
      type,
    });
  };

  const {
    bulkActions,
    isBulkActions,
    isBulkActionsSuccess,
    bulkActionsError,
  } = useBulkActions();

  useEffect(() => {
    if (isBulkActionsSuccess) {
      ToastService.success("Action completed successfully");
      setDeclinePopoverVisible(false);
      setBucketModalVissible(false);
      setPricingPocModalProps({
        visible: false,
        briefInfluencerId: [],
        type: "assign",
      });
      setSelectedRowKeys([]);
      setSelectedRows([]);
      setSelectAll?.(false);
      setUncheckList?.([]);
      refetch?.();
    } else if (bulkActionsError) {
      ToastService.error(bulkActionsError?.message);
    }
  }, [isBulkActionsSuccess, bulkActionsError]);

  const handleCreatorDecline = (values: { reason: string }) => {
    bulkActions({
      briefId,
      actionType: BriefNotificationActionType.declineInfluencer,
      ids: selectedRowKeys as string[],
      notIncludeIds: uncheckList || [],
      isSelectAll: selectAll,
      filterParams: params || {},
      actionParams: {
        declineInfluencerParams: { reason: values.reason },
      },
    });
  };

  const handleBrandDecline = () => {
    bulkActions({
      briefId,
      actionType: BriefNotificationActionType.declineBrand,
      ids: selectedRowKeys as string[],
      notIncludeIds: uncheckList || [],
      isSelectAll: selectAll,
      filterParams: params || {},
      actionParams: {},
    });
  };

  const handleDeleteSelected = () => {
    bulkActions({
      briefId,
      actionType: BriefNotificationActionType.deleteInfluencer,
      ids: selectedRowKeys as string[],
      notIncludeIds: uncheckList || [],
      isSelectAll: selectAll,
      filterParams: params || {},
      actionParams: {},
    });
  };

  const handleAdd = (bucketId: string) => {
    bulkActions({
      briefId,
      actionType: BriefNotificationActionType.addInfluencersToBucket,
      ids: selectedRowKeys as string[],
      notIncludeIds: uncheckList || [],
      isSelectAll: selectAll,
      filterParams: params || {},
      actionParams: {
        addInfluencersToBucketParams: {
          bucketId,
        },
      },
    });
  };

  return (
    <>
      {(selectAll || selectedRowKeys.length > 0) && (
        <>
          {/* <Button onClick={() => setSuggestModalOpen(true)}>
            Suggest in a campaign ({selectedRowKeys.length})
          </Button>
          <Button onClick={() => setIsSuggestInfluencerPricingModalOpen(true)}>
            Copy Influencers ({selectedRowKeys.length})
          </Button> */}
          <Popover
            open={declinePopoverVisible}
            onOpenChange={(visible) => {
              if (!visible) {
                setDeclinePopoverVisible(false);
              }
            }}
            trigger={[]}
            content={
              <div style={{ padding: "4px" }}>
                <Form
                  form={form}
                  onFinish={(values) => {
                    handleCreatorDecline(values);
                  }}
                >
                  <Form.Item
                    name="reason"
                    rules={[
                      {
                        required: true,
                        message: "Please enter reason to decline.",
                      },
                    ]}
                  >
                    <Input.TextArea
                      placeholder="Enter reason to decline..."
                      rows={3}
                      style={{ marginBottom: 8, width: 250 }}
                    />
                  </Form.Item>
                  <Flex justify="end" gap={8}>
                    <Form.Item>
                      <Button
                        size="small"
                        onClick={() => setDeclinePopoverVisible(false)}
                      >
                        Cancel
                      </Button>
                    </Form.Item>
                    <Form.Item>
                      <Button
                        size="small"
                        type="primary"
                        htmlType="submit"
                        loading={isBulkActions}
                      >
                        Confirm
                      </Button>
                    </Form.Item>
                  </Flex>
                </Form>
              </div>
            }
            title="Creator Declined"
          >
            <Dropdown
              trigger={["click"]}
              menu={{
                items: [
                  {
                    label: (
                      <span>Add to Bucket ({effectiveCount})</span>
                    ),
                    key: "add-to-bucket",
                    // disabled: selectedRowKeys.length > 100,
                    onClick: () => setBucketModalVissible(true),
                  },
                  {
                    label: (
                      <span>Add to Campaign ({effectiveCount})</span>
                    ),
                    key: "add-to-campaign",
                    onClick: () => setOpenAddToCampaignProps({ open: true }),
                  },
                  { type: "divider" },
                  {
                    label: "Creator Declined",
                    key: "creator-declined",
                    onClick: () => {
                      setDeclineType("creator");
                      form.resetFields();
                      setDeclinePopoverVisible(true);
                    },
                  },
                  {
                    label: "Brand Declined",
                    key: "brand-declined",
                    onClick: () => {
                      handleBrandDecline();
                    },
                  },
                  { type: "divider" },
                  {
                    label: (
                      <Popconfirm
                        title="Delete creators"
                        description={`Are you sure you want to delete ${effectiveCount} selected creator(s)? This action cannot be undone.`}
                        onConfirm={handleDeleteSelected}
                        okText="Delete"
                        cancelText="Cancel"
                        okButtonProps={{ danger: true, loading: isBulkActions }}
                      >
                        <span
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                          }}
                        >
                          Delete ({effectiveCount})
                        </span>
                      </Popconfirm>
                    ),
                    key: "delete",
                    danger: true,
                  },
                ],
              }}
            >
              <Button
                icon={<MoreOutlined />}
                loading={isBulkActions}
              />
            </Dropdown>
          </Popover>
          <AddCustomFieldsDataButton
            selectAll={selectAll}
            checkedList={selectedRowKeys as string[]}
            uncheckList={uncheckList}
            searchPayload={params || {}}
            totalCount={totalCount || selectedRowKeys.length}
            onSuccess={updateBriefInfluencers}
            visibleColumns={visibleCustomFields}
          />
          <Dropdown
            trigger={["click"]}
            placement="bottomRight"
            menu={{
              items: [
                ...[
                  {
                    label: "Send for Pricing",
                    key: "assign-pricing-poc",
                    onClick: () => {
                      openPricingPocModal(
                        selectedRowKeys as string[],
                        "assign"
                      );
                    },
                  },
                ],
                ...(isReAssginOrRemoveVisible
                  ? [
                      {
                        label: "Reallocate Pricing POC",
                        key: "reassign-pricing-poc",
                        onClick: () => {
                          openPricingPocModal(
                            selectedRowKeys as string[],
                            "reassign"
                          );
                        },
                      },
                      {
                        label: "Remove Pricing POC",
                        key: "remove-pricing-poc",
                        onClick: () => {
                          openPricingPocModal(
                            selectedRowKeys as string[],
                            "remove"
                          );
                        },
                      },
                    ]
                  : []),
              ],
            }}
          >
            <Button
              icon={<UpOutlined size={16} />}
              iconPosition="end"
              type="primary"
            >
              Pricing Actions
            </Button>
          </Dropdown>
          <AddDeliverablesButton
            selectAll={selectAll}
            searchPayload={params || {}}
            checkedList={selectedRowKeys as string[]}
            uncheckList={uncheckList}
            totalCount={totalCount}
            handleUpdateBriefInfluencer={updateBriefInfluencers}
            onSuccess={() => {
              setSelectedRowKeys([]);
              setSelectedRows([]);
            }}
            buttonProps={{
              type: "primary",
              children: `Edit Deliverables (${effectiveCount})`,
            }}
          />
          <Button type="primary" onClick={handleBulkPurchase}>
            Purchase ({effectiveCount})
          </Button>
        </>
      )}
      {/* Drawer for selecting/creating deliverables */}
      {/* <Drawer
        title="Select Deliverable"
        open={
          deliverableModalProps.visible &&
          deliverableModalProps.type === "create"
        }
        onClose={() => {
          setDeliverableModalProps({
            visible: false,
            type: "create",
            deliverableId: "",
            briefInfluencerIds: [],
          });
          setSelectedDeliverableForAttach(null);
        }}
        width={800}
        destroyOnClose
        bodyStyle={{ padding: 0 }}
        footer={
          <Flex
            justify="flex-end"
            style={{
              padding: "16px 24px",
              // borderTop: "1px solid #f0f0f0",
              position: "sticky",
              bottom: 0,
              background: "#fff",
              zIndex: 10,
            }}
          >
            <Button
              type="primary"
              disabled={!selectedDeliverableForAttach}
              title={
                selectedDeliverableForAttach
                  ? ""
                  : "Please select a deliverable."
              }
              loading={isAttaching}
              onClick={() => {
                if (selectedDeliverableForAttach) {
                  attachBriefDeliverable({
                    deliverableId: selectedDeliverableForAttach._id,
                    briefInfluencerIds:
                      deliverableModalProps.briefInfluencerIds || [],
                  });
                }
              }}
            >
              Attach
            </Button>
          </Flex>
        }
      >
        {deliverableModalProps.visible &&
          deliverableModalProps.type === "create" && (
            <CampaignDeliverables
              showTitle={false}
              selectedDeliverableId={brief?.defaultDeliverableV2Id}
              isEditable={true}
              briefInfluencerIds={deliverableModalProps.briefInfluencerIds}
              onClose={() =>
                setDeliverableModalProps({
                  visible: false,
                  type: "create",
                  deliverableId: "",
                  briefInfluencerIds: [],
                })
              }
              onSelectedDeliverableChange={(deliverable) => {
                setSelectedDeliverableForAttach(
                  deliverable ? { _id: deliverable._id || "" } : null
                );
              }}
            />
          )}
      </Drawer> */}

      {/* Modal for viewing/editing deliverable packages */}
      {/* <Modal
        title={
          deliverableModalProps.type === "view"
            ? "View Deliverable"
            : "Edit Deliverable"
        }
        open={
          deliverableModalProps.visible && deliverableModalProps.type === "view"
        }
        onCancel={() =>
          setDeliverableModalProps({
            visible: false,
            type: "create",
            deliverableId: "",
            briefInfluencerIds: [],
          })
        }
        footer={null}
        width={800}
        destroyOnClose
      >
        {deliverableModalProps.type === "view" && (
          <DeliverablePackageCard
            briefId={briefId}
            defaultDeliverableId={brief?.defaultDeliverableV2Id}
            briefInfluencerIds={deliverableModalProps.briefInfluencerIds}
            isEditable={true}
            showMarkDefaultButton
            onClose={() =>
              setDeliverableModalProps({
                visible: false,
                type: "create",
                deliverableId: "",
                briefInfluencerIds: [],
              })
            }
            deliverableId={deliverableModalProps.deliverableId || ""}
          />
        )}
      </Modal> */}

      <Modal
        title={
          infCommercialsModalProps.type === "create"
            ? "Create Influnencer Commericals"
            : infCommercialsModalProps.type === "view"
              ? "Edit Influnencer Commericals"
              : "Add new Influnencer Commericals"
        }
        open={infCommercialsModalProps.visible}
        onCancel={() =>
          setInfluencerModalProps({
            visible: false,
            type: "create",
            briefInfluencer: undefined,
          })
        }
        footer={null}
        width={800}
        destroyOnClose
      >
        {infCommercialsModalProps.visible &&
          infCommercialsModalProps.briefInfluencer && (
            <InfluencerCommercial
              onClose={() =>
                setInfluencerModalProps({
                  visible: false,
                  type: "create",
                  briefInfluencer: undefined,
                })
              }
              briefInfluencer={infCommercialsModalProps.briefInfluencer}
              type={infCommercialsModalProps.type}
            />
          )}
      </Modal>
      <Modal
        title={
          brandCommercialsModalProps.type === "view"
            ? "Edit brand Commericals"
            : "Add new brand Commericals"
        }
        open={brandCommercialsModalProps.visible}
        onCancel={() =>
          setBrandluencerModalProps({
            visible: false,
            type: "view",
            briefInfluencer: undefined,
          })
        }
        footer={null}
        width={800}
        destroyOnClose
      >
        {brandCommercialsModalProps.visible &&
          brandCommercialsModalProps.briefInfluencer && (
            <BrandCommercial
              onClose={() =>
                setBrandluencerModalProps({
                  visible: false,
                  type: "view",
                  briefInfluencer: undefined,
                })
              }
              briefInfluencer={brandCommercialsModalProps.briefInfluencer}
              type={brandCommercialsModalProps.type}
            />
          )}
      </Modal>
      <Modal
        title={"Purchase Confirmation"}
        open={purchaseModalProps.visible}
        onCancel={() =>
          setPurhcaseModalProps({
            visible: false,
            briefInfluencers: undefined,
          })
        }
        // okText="Confirm Purchase"
        // okButtonProps={{
        //   type: "primary",
        //   loading: isPurchasing,
        // }}
        width={1500}
        footer={null}
        destroyOnClose
      >
        <PurchaseConfirmation
          onClose={() =>
            setPurhcaseModalProps({
              visible: false,
              briefInfluencers: undefined,
            })
          }
          briefInfluencers={[...(purchaseModalProps.briefInfluencers || [])]}
        />
      </Modal>
      {/* NON_PROFITABLE Modal */}
      <Modal
        open={showNonProfitableModal}
        title="Non Profitable Deal"
        onCancel={() => setShowNonProfitableModal(false)}
        okButtonProps={{
          type: "primary",
          loading: isPurchasingNonProfitable,
        }}
        onOk={async () => {
          if (purchaseResult?.result?.length) {
            for (const { briefInfluencer } of purchaseResult.result) {
              await purchaseNonProfitable(briefInfluencer._id);
            }
          }
        }}
      >
        {purchaseResult?.result.map(({ status, reason, briefInfluencer }) => (
          <div key={briefInfluencer._id} style={{ marginBottom: 16 }}>
            <div>Brand Price is {briefInfluencer.brandCost?.cost}</div>
            <div>
              Influencer Commercials is{" "}
              {briefInfluencer.brandCost?.influencerCost?.cost}
            </div>
            <div>Revenue is {briefInfluencer?.brandCost?.revenue}</div>
            <b>Are you sure you want to make this purchase?</b>
          </div>
        ))}
      </Modal>
      {/* Purchase Precheck Modal — shows valid/invalid creator split */}
      <Modal
        title="Review Purchase"
        open={purchasePreCheckVisible}
        onCancel={() => setPurchasePreCheckVisible(false)}
        footer={null}
        width={900}
        destroyOnClose
        loading={isPurchaseStatusFetching}
      >
        <PurchasePreCheckModalContent
          validCreators={preCheckValidCreators}
          invalidCreators={preCheckInvalidCreators}
          onRemoveCreator={(id) =>
            setPreCheckValidCreators((prev) => prev.filter((c) => c._id !== id))
          }
          onCancel={() => setPurchasePreCheckVisible(false)}
          onConfirm={() => {
            setPurchasePreCheckVisible(false);
            setPurhcaseModalProps({
              visible: true,
              briefInfluencers: preCheckValidCreators,
            });
          }}
          isPurchasing={false}
        />
      </Modal>
      {/* Pre-confirm Modal for Bulk Purchase (negotiation / brand-pending warning) */}
      <Modal
        open={preConfirmModal.visible}
        title="Confirm"
        onCancel={() => setPreConfirmModal((m) => ({ ...m, visible: false }))}
        onOk={() => {
          setPreConfirmModal((m) => ({ ...m, visible: false }));
          setPurchasePreCheckVisible(true);
        }}
        okText="Confirm"
      >
        {preConfirmModal.negotiationCount > 0 && (
          <div style={{ marginBottom: 16 }}>
            <b>{preConfirmModal.negotiationCount} Negotiation Requested</b>
            <div>
              Cannot purchase creator's for whom negotiation's are requested .
            </div>
          </div>
        )}
        {preConfirmModal.brandPendingCount > 0 && (
          <div style={{ marginBottom: 16 }}>
            <b>
              {preConfirmModal.brandPendingCount} New Brand Commercial's Pending
            </b>
            <div>
              New commercial's have been added for{" "}
              {preConfirmModal.brandPendingCount} creator's and their brand
              price hasn't been updated, cannot purchase such creators.
            </div>
          </div>
        )}
      </Modal>

      <Modal
        title={"Verify Contact"}
        open={conatcsModalProps.visible}
        onCancel={() =>
          setContactsModalProps({
            visible: false,
            briefInfluencerId: "",
            creatorInfo: undefined,
            conatcts: [],
            initialContact: null,
          })
        }
        footer={null}
        width={800}
        destroyOnClose
      >
        {conatcsModalProps.visible && conatcsModalProps.creatorInfo && (
          <SelectContact
            initialContact={conatcsModalProps.initialContact}
            briefInfluencerId={conatcsModalProps.briefInfluencerId || ""}
            onSuccess={(briefInfluencer: IBriefInfluencerV2) => {
              if (!conatcsModalProps.addContactOnly) {
                setInfluencerModalProps({
                  visible: true,
                  briefInfluencer: briefInfluencer,
                  type: "create",
                });
              }
            }}
            onClose={() =>
              setContactsModalProps({
                visible: false,
                briefInfluencerId: "",
                creatorInfo: undefined,
                conatcts: [],
                addContactOnly: false,
                initialContact: null,
              })
            }
            creatorInfo={conatcsModalProps.creatorInfo}
          />
        )}
      </Modal>
      <Modal
        destroyOnClose
        title={"Suggest selected influencers in a campaign"}
        open={isSuggestModalOpen}
        onCancel={() => {
          setSuggestModalOpen(false);
        }}
        footer={null}
        width={1000}
      >
        <SuggestCampaignFromBriefForm
          creators={selectedRows || []}
          onClose={() => {
            setSelectedRows([]);
            setSelectedRowKeys([]);
            setSuggestModalOpen(false);
          }}
        />
      </Modal>
      <Modal
        destroyOnClose
        title={"Copy selected influencers in a campaign"}
        open={isSuggestInfluencerPricingModalOpen}
        onCancel={() => {
          setIsSuggestInfluencerPricingModalOpen(false);
        }}
        footer={null}
        width={1000}
      >
        <SuggestInfluencerPricingForm
          briefInfluencerIds={selectedRowKeys.map((key) => key as string) || []}
          handleSuccess={() => {
            setSelectedRowKeys([]);
            setIsSuggestInfluencerPricingModalOpen(false);
            setSelectedRows([]);
          }}
          onClose={() => {
            setIsSuggestInfluencerPricingModalOpen(false);
          }}
        />
      </Modal>
      <Modal
        title="Add Influencer To Bucket"
        open={isBucketModalVisible}
        onCancel={() => setBucketModalVissible(false)}
        footer={
          <>
            <Divider style={{ margin: "8px 0" }} />
            <Space
              style={{
                padding: "0 8px 4px",
                width: "100%",
                justifyContent: "space-between",
              }}
            ></Space>
            {bucketId ? (
              <Row style={{ justifyContent: "center", padding: 10 }}>
                {isBulkActions ? (
                  <Spin style={{ width: 30, height: 30 }} />
                ) : (
                  <Button
                    onClick={async () => handleAdd(bucketId)}
                    icon={<PlusOutlined />}
                  >
                    Add to selected bucket
                  </Button>
                )}
              </Row>
            ) : null}
          </>
        }
        destroyOnClose
      >
        <AddToBucket
          bucketIds={[bucketId]}
          setselectedbuckedIds={(val) => setselectedbuckedId(typeof(val) === "string" ? val : val?.[0])}
        />
      </Modal>

      <AddToCampaignFromBrief
        briefId={briefId}
        isInAll={false}
        onClose={() => {
          setOpenAddToCampaignProps({ open: false });
        }}
        open={openAddToCampaignProps.open}
        selectedBriefInfluencers={selectedRowKeys as string[]}
        selectAll={selectAll || false}
        checkedList={selectedRowKeys as string[]}
        totalCount={totalCount || selectedRowKeys.length}
        uncheckList={uncheckList || []}
        searchPayload={params || {}}
      />

      <Modal
        open={pricingPocModalProps.visible}
        onCancel={() =>
          setPricingPocModalProps({
            visible: false,
            briefInfluencerId: [],
            type: "assign",
          })
        }
        footer={null}
        title={
          pricingPocModalProps.type === "assign"
            ? "Assign Pricing POC"
            : pricingPocModalProps.type === "reassign"
              ? "Reallocate Pricing POC"
              : "Remove Pricing POC"
        }
        destroyOnClose
        width={700}
      >
        {pricingPocModalProps.visible && (
          <AssignPricingModalV2
            briefInfluencerIds={pricingPocModalProps.briefInfluencerId}
            type={pricingPocModalProps.type}
            selectAll={selectAll}
            uncheckList={uncheckList}
            totalCount={totalCount}
            onClose={() =>
              setPricingPocModalProps({
                visible: false,
                briefInfluencerId: [],
                type: "assign",
              })
            }
            isLoading={isBulkActions}
            onConfirm={(data) => {
              if (pricingPocModalProps.type === "assign") {
                bulkActions({
                  briefId,
                  actionType: BriefNotificationActionType.assignPricingPoc,
                  ids: selectedRowKeys as string[],
                  notIncludeIds: uncheckList,
                  isSelectAll: selectAll,
                  filterParams: params || {},
                  actionParams: {
                    assignPricingPocParams: {
                      assignedToUserId: data.assignedToUserId,
                      briefId,
                      deadlineFrom: data.deadlineFrom,
                      deadlineTo: data.deadlineTo,
                      pricingOutreachTerms: data.pricingOutreachTerms,
                    },
                  },
                });
              } else if (pricingPocModalProps.type === "reassign") {
                bulkActions({
                  briefId,
                  actionType: BriefNotificationActionType.reallocatePricingPoc,
                  ids: selectedRowKeys as string[],
                  notIncludeIds: uncheckList,
                  isSelectAll: selectAll,
                  filterParams: params || {},
                  actionParams: {
                    reallocatePricingPocParams: {
                      reallocatedToUserId: data.assignedToUserId,
                      briefId,
                      deadlineFrom: data.deadlineFrom,
                      deadlineTo: data.deadlineTo,
                      pricingOutreachTerms: data.pricingOutreachTerms,
                    },
                  },
                });
              } else {
                bulkActions({
                  briefId,
                  actionType: BriefNotificationActionType.removePricingPoc,
                  ids: selectedRowKeys as string[],
                  notIncludeIds: uncheckList,
                  isSelectAll: selectAll,
                  filterParams: params || {},
                  actionParams: {
                    removePricingPocParams: {
                      briefId,
                    },
                  },
                });
              }
            }}
          />
        )}
      </Modal>
    </>
  );
}
